<template>
    <button :type="type"
            :class="`font-josefin font-semibold text-${colour}-600 disabled:text-gray-200 tracking-wider text-sm uppercase px-6 py-3 border-solid border-2 border-${colour}-600 disabled:border-gray-200 inline-block hover:bg-${colour}-600 disabled-hover:bg-white hover:text-white my-2 sm:my-4 transition ease-in-out duration-150`"
            :disabled="disabled"
    >
        <slot></slot>
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'button'
            },

            colour: {
                type: String,
                default: 'primary'
            },

            disabled: {
                type: Boolean,
                default: false
            }
        },
    }
</script>
